<div class="row align-items-center justify-content-end">
  <div class="col-md-auto label-text">{{phase.PhaseName}}</div>

    <div class="progress">
      <div [class.progress-inprogress]="phase.PercentComplete < 100"
           [class.progress-complete]="phase.PercentComplete === 100"
           class="progress-bar" role="progressbar"
           [style.width]="phase.PercentComplete+'%'" attr.aria-valuenow="{{phase.PercentComplete}}" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>

  <div class="col col-md-2 label-text">{{phase.PercentComplete}}%</div>
</div>
